// Values match the field names on the travelData GraphQL type.
enum TravelIndustry {
  AIRLINE = "airline",
  LODGING = "lodging",
  CAR_RENTAL = "carRental",
  RAIL = "rail",
}

export default TravelIndustry;
